// Adjust Redo protection checkbox colors to match dark theme
(function(){
  const COLOR = '#ffffff';
  function restyle(el){
    try {
      if(!el.shadowRoot) return;
      // Inject (or update) our own style block inside the shadow root for persistent override
      let style = el.shadowRoot.querySelector('style[data-redo-override]');
      if(!style){
        style = document.createElement('style');
        style.dataset.redoOverride = 'true';
        el.shadowRoot.appendChild(style);
      }
      style.textContent = `:host, [data-target="checkbox-root"], [data-target="checkbox-label"], [data-target="checkbox-info"] { color: ${COLOR} !important; }
      [data-target="checkbox-label"], [data-target="checkbox-info"] { opacity: .92; }`;
      // Optional: expose a CSS var for future theming
      el.style.setProperty('--redo-theme-text-color', COLOR);
    } catch(e){ /* ignore */ }
  }
  function scan(){ document.querySelectorAll('redo-shopify-checkbox').forEach(restyle); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  new MutationObserver(muts=>{
    let found=false; for(const m of muts){ for(const n of m.addedNodes){ if(n.nodeType===1 && n.matches && n.matches('redo-shopify-checkbox')) { found=true; } } }
    if(found) scan();
  }).observe(document.documentElement,{childList:true, subtree:true});
})();
